import { render } from "./ControleCobrancasGarantePayView.vue?vue&type=template&id=2227a80e&scoped=true"
import script from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasGarantePayView.vue?vue&type=script&lang=js"

import "./ControleCobrancasGarantePayView.vue?vue&type=style&index=0&id=2227a80e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2227a80e"]])

export default __exports__